<div class="container-fluid">
  <div class="row pt-4 pl-4" style="font-size: 22px !important;
  font-weight: 400; color: #424242;" *ngIf="!isMyReport">
    <h5><i class="fa fa-circle" style="color:#800000"></i> &nbsp;Article 1/6th Report</h5>
  </div>
  <div class="container" id="mainContent">
    <div class="modal-body" *ngIf="!isMyReport">
      <div class="row mt-2">
        <div class="col-sm-6">
          <div class="row">
            <label class="col-sm-4 col-form-label">Branch<span class="text-danger">*</span></label>
            <div class="col-sm-6">
              <mat-form-field appearance="legacy" style="width: 100%">
                <mat-select multiple [(ngModel)]="selectedBranch" #designateBranch="ngModel">
                  <mat-option (click)="selectAllBranch(designateBranch, branchList)" [value]="0">Select All
                  </mat-option>
                  <mat-option (click)="selectBranch()" #item *ngFor="let branch of branchList" [value]="branch">
                    {{ branch.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        </div>

        <div class="col-sm-6">
          <div class="row">
            <label class="col-sm-4 col-form-label">Reporting Partner<span class="text-danger">*</span></label>
            <div class="col-sm-6">
              <select class="form-control form-control-xs mt-1" [(ngModel)]="selectedPartner"
                (change)="onUserSelected()">
                <option value="">Select Partner</option>
                <option *ngFor="let partner of partnerList" [ngValue]="partner">
                  {{ partner.firstName }} {{ partner.middleName }}
                  {{ partner.lastName }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>

      <div class="row mt-2">
        <div class="col-sm-6">
          <div class="row">
            <label class="col-sm-4 col-form-label">Article Name<span class="text-danger">*</span></label>
            <div class="col-sm-6">
              <select class="form-control form-control-xs mt-1" [(ngModel)]="selectedUser"
                (change)="selectedUserName(selectedUser)">
                <option value="">Select Article</option>
                <option *ngFor="let user of userList" [ngValue]="user">
                  {{ user.firstName }} {{ user.middleName }}
                  {{ user.lastName }}
                </option>
              </select>
            </div>
          </div>
        </div>

        <div class="col-sm-6">
          <div class="row">
            <div class="col-sm-4">
              <label>ICAIReg. Date <span class="text-danger">*</span> </label>
            </div>
            <div class="col-sm-6">
              <div class="input-group">
                <input class="form-control form-control-xs" [(ngModel)]="ICAIRegDate" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row mt-4">
        <div class="col-sm-6">
          <div class="row">
            <div class="col-sm-4">
              <label>To Date <span class="text-danger">*</span> </label>
            </div>

            <div class="col-sm-6">
              <div class="input-group">
                <input class="form-control form-control-xs" placeholder="dd/mm/yyyy" name="fromDate" ngbDatepicker
                  #fromDate="ngbDatepicker" [placement]="'bottom'" [(ngModel)]="selectedDate" />
                <div class="input-group-append">
                  <button class="btn btn-outline-theme calendar" (click)="fromDate.toggle()" type="button"></button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="row">
            <div class="col-sm-4">
              <button class="btn btn-sm btn-block btn-outline-theme" (click)="onViewReport()">
                View Details
              </button>
            </div>
            <div class="col-sm-4" *ngIf="showReportDetail">
              <button (click)="exportToExcelClick()" class="btn btn-sm btn-block btn-outline-theme">
                <i class="fa fa-file-excel-o mr-2"></i>Export to Excel
              </button>
            </div>
            <div class="col-sm-4" *ngIf="showReportDetail">
              <button (click)="exportToPDFClick()" class="btn btn-sm btn-block btn-outline-theme">
                <i class="fa fa-file-excel-o mr-2"></i>Export as PDF
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="container" id="mainContent">
    <div *ngIf="showReportDetail" id="elementsForPDF">
      <div class="row pt-3 justify-content-center text-center">
        <span class="bg-theme-title">P G BHAGWAT LLP, Chartered Accountants
        </span>
      </div>
      <div class="row justify-content-center text-center ">
        <span>Suite 102, "Orchard", Dr Pai Marg, Baner, Pune - 411045 </span>
      </div>
      <div>
        <div class="pt-3" style="padding-left: 40px;padding-right: 40px;">
          <div class="row" style="border: 1px solid; border-bottom: 0px">
            <div class="col-sm-12">
              <span class="bg-theme-title">Article Name : </span>
              <span class="bg-theme-title">{{ reportList.firstName }} {{ reportList.middleName }}
                {{ reportList.lastName }}</span>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-8 border_class_left_column">
              <span class="bg-theme-title">ICAIRegistration Date</span>
            </div>
            <div class="col-sm-4 border_class_right_column">
              {{ reportList.icaiRegistrationDate | date: "dd-MMM-yyyy" }}
            </div>
          </div>
          <div class="row">
            <div class="col-sm-8 border_class_left_column">
              <span class="bg-theme-title">1/6th Calculation Date</span>
            </div>
            <div class="col-sm-4 border_class_right_column">
              {{ reportList.calculationDate | date: "dd-MMM-yyyy" }}
            </div>
          </div>
          <div class="row">
            <div class="col-sm-8 border_class_left_column">
              <span class="bg-theme-title">Total Period Served In Days</span>
            </div>
            <div class="col-sm-4 border_class_right_column">
              {{ reportList.serveDays }}
            </div>
          </div>
          <div class="row">
            <div class="col-sm-8 border_class_left_column">
              <span class="bg-theme-title">1/6th Eligibility of CA Exam Leave In Days</span>
            </div>
            <div class="col-sm-4 border_class_right_column">
              {{ eligibilityOfCAExamLeaveInDaysIntegerValue }}
            </div>
          </div>
          <div class="row border_class">
            <div class="col-sm-12 text-center">
              <span class="font_style">DEDUCTIONS (LEAVES) IN DAYS</span>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-8 border_class_left_column">
              <span class="bg-theme-title">BCOM Exam Leave / other exam</span>
            </div>
            <div class="col-sm-4 border_class_right_column">
              {{ reportList.bCOMExamLeave }}
            </div>
          </div>
          <div class="row">
            <div class="col-sm-8 border_class_left_column">
              <span class="bg-theme-title">Casual leave(sick or other personal)</span>
            </div>
            <div class="col-sm-4 border_class_right_column">
              {{ reportList.casualLeave }}
            </div>
          </div>
          <div class="row border_class">
            <div class="col-sm-12 text-center">
              <span class="font_style">DIARY DEBITS / CREDITS IN DAYS</span>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-8 border_class_left_column">
              <span class="bg-theme-title">Debit</span>
            </div>
            <div class="col-sm-4 border_class_right_column">
              {{ reportList.debit }}
            </div>
          </div>
          <div class="row">
            <div class="col-sm-8 border_class_left_column">
              <span class="bg-theme-title">Credit</span>
            </div>
            <div class="col-sm-4 border_class_right_column">
              {{ reportList.credit }}
            </div>
          </div>
          <div class="row border_class">
            <div class="text-center col-sm-12">
              <span class="font_style">FINAL CALCULATION IN DAYS</span>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-8 border_class_left_column">
              <span class="bg-theme-title">Net Dr. / Cr.</span>
            </div>
            <div class="col-sm-4 border_class_right_column">
              {{ reportList.netDrCr }}
            </div>
          </div>
          <div class="row">
            <div class="col-sm-8 border_class_left_column">
              <span class="bg-theme-title">Final 1/6th Eligibility of CA Exam Leave (1/6th Eligibility-Net Dr.
                )
              </span>
            </div>
            <div class="col-sm-4 border_class_right_column">
              {{ reportList.finalEligibilityOfCAExamLeave }}
            </div>
          </div>
          <div class="row">
            <div class="col-sm-8 border_class_last_row_left_column">
              <span class="bg-theme-title">1/6th Eligibility ( 2nd Attempt)</span>
            </div>
            <div class="col-sm-4 border_class_last_row_right_column">
              {{ reportList.eligibility2ndAttempt }}
            </div>
          </div>

          <div class="row border_class mt-5">
            <div class="text-center col-sm-12">
              <span class="font_style">LEAVES</span>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-8 border_class_left_column">
              <span class="bg-theme-title"> GMCS 1</span>
            </div>
            <div class="col-sm-4 border_class_right_column">
              {{ reportList.gMCS1 }}
            </div>
          </div>
          <div class="row">
            <div class="col-sm-8 border_class_left_column">
              <span class="bg-theme-title"> GMCS 2 </span>
            </div>
            <div class="col-sm-4 border_class_right_column">
              {{ reportList.gMCS2 }}
            </div>
          </div>
          <div class="row">
            <div class="col-sm-8 border_class_left_column">
              <span class="bg-theme-title"> CA Exam Leave Days </span>
            </div>
            <div class="col-sm-4 border_class_right_column">
              {{ reportList.eligibilityOfCAExamLeave }}
            </div>
          </div>
          <div class="row pb-4">
            <div class="col-sm-8 border_class_last_row_left_column">
              <span class="bg-theme-title"> Actual CA Exam Days </span>
            </div>
            <div class="col-sm-4 border_class_last_row_right_column">
              {{ reportList.actualCAExamDays }}
            </div>
          </div>
          <!-- <div class="row">
          <div class="col-sm-8 border_class_last_row_left_column">
            <span class="bg-theme-title"> Exam Leave ( Old Leave Type)</span>
          </div>
          <div class="col-sm-4 border_class_last_row_right_column">
            {{ reportList.eligibilityOfCAExamLeave }}
          </div>
        </div> -->
        </div>
      </div>
    </div>
  </div>
</div>